import PageWrapper from 'shared/PageWrapper/PageWrapper';

export default PageWrapper;
